import { Stage } from "../lusca-search-api/generated-src";

export const isDevo = (stage: Stage): boolean =>
  stage === Stage.Dev || stage === Stage.Beta;
